import { Application } from "stimulus";
export const application = Application.start();

import Flatpickr from "stimulus-flatpickr";
import("flatpickr/dist/flatpickr.css");
application.register("flatpickr", Flatpickr);